export default "<p>\r\n  charges works!\r\n</p>\r\n";